import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import firebase from 'firebase'; 
import { firebaseConfig } from './configuracion/firebaseConfig';
 // Initialize Firebase
 firebase.initializeApp(firebaseConfig);
 export const db = firebase.firestore();

 import 'bootstrap';
import { BootstrapVue, IconsPlugin } from 'bootstrap-vue';
//import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css';

import moment from "moment";
import "moment/locale/es";


Vue.config.productionTip = false


// Install BootstrapVue
Vue.use(BootstrapVue)
// Optionally install the BootstrapVue icon components plugin
Vue.use(IconsPlugin)

// register jw pagination component globally
import JwPagination from 'jw-vue-pagination';
Vue.component('jw-pagination', JwPagination);


Vue.filter('mayuscula',(texto)=>{
  return texto.toUpperCase();
})

Vue.filter('formatofecha',(mifecha) => {  
  return moment(mifecha).format('LLLL');
});

Vue.filter('formatofecha2',(mifecha) => {    
  const fechasal =  (moment(mifecha).add(8, 'hours'));
  console.log(moment(mifecha).format('LLLL'));
  console.log(moment(fechasal).format('LLLL'));
  //const diferencia = fechasal - mifecha;
  //console.log(moment(diferencia).format());
  console.log(moment(mifecha).startOf('hour').fromNow()); 
  return moment(fechasal).format('LLLL');
})







new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
